

function clearTextSelection() {
   if (window.getSelection) {
      if (window.getSelection().empty) {  // Chrome
         window.getSelection().empty();
      }
      else if (window.getSelection().removeAllRanges) {  // Firefox
         window.getSelection().removeAllRanges();
      }
   }
   else if (document.selection) {  // IE?
      document.selection.empty();
   }
}

export class DataView {

   constructor(container) {
      this.sortOrder = new Array();

      this.data = null;
      this.selIndex = 0;
      this.numVisibleColumns = 0;
      this.container = container;
      this.sortSettings = [];
      this.defaultSettings = {
         list: this,
         oddEven: true,
         showHeader: true,
         multiSelect: false,
         onExpand: false
      };

      this.container.empty();
      this.container.classList.add('dataview');

      document.addEventListener('keyup', () => {
         if (this.sortSettings.length > 0) {
            this.setupSortSettings();
            this.render();
         }
      });

   }

   dataGetter(item, dataGetter) {
      if      (typeof(dataGetter) === 'string')   return item[dataGetter];
      if      (typeof(dataGetter) === 'boolean')  return dataGetter;
      else if (typeof(dataGetter) === 'function') return dataGetter(item);
   }

   getValue(item, name, data) {
      return typeof(item[name]) === 'function' ? item[name](data) : data[item[name]];
   }

   sortIt(obj) {

      return function(a,b) {

         for (let sortOrder of obj.sortOrder) {
            const column = sortOrder.column;

            const dataA = (column.sort.value === undefined ? obj.dataGetter(a, column.data) : column.sort.value(a));
            const dataB = (column.sort.value === undefined ? obj.dataGetter(b, column.data) : column.sort.value(b));

            if (dataA < dataB) return -1 * column.sort.dir;
            else if (dataA > dataB) return 1 * column.sort.dir;

         }

         return 0;

      };

   }

   setupSortSettings() {

      for (let column of this.columns) {
         if (column.sort !== undefined) {
            column.sort.index = 0;
         }
      }

      for (let i=0; i<this.sortSettings.length; ++i) {
         const colIndex = this.sortSettings[i];
         this.columns[colIndex].sort.index = Number(i)+1;
      }

      this.sortSettings = [];

   }

   getMultiActionItems() {
      let items = new Array();
      if (this.table) {
         this.table.querySelectorAll('input.multiaction').forEach(function(item) {
            if (item.checked) {
               items.push(item.parents('tr.dataview-row')[0].getData('dv-item'));
            }
         });
      }

      return items;
   }

   select(row, shiftKey, ctrlKey) {

      // einfache Auswahl
      if (!this.set.multiSelect) {
         this.removeSelection();
         row.classList.add('dv-selected');
         this.set.onSelected(row.getData('dv-item'), row);
      }

      // mehrfache Auswahl
      else {

         clearTextSelection();

         if (ctrlKey) {
            row.classList.toggle('dv-selected');
            this.set.onSelected(this.getSelectedData(), row);
         }
         else if (shiftKey) {

            const selIndex = [...row.parentNode.children].indexOf(row)

            if (selIndex < this.selIndex) {
               for (let i=selIndex; i<this.selIndex; ++i) {
                  this.table.querySelectorAll('tr')[i].classList.add('dv-selected');
               }
            }
            else if (selIndex > this.selIndex) {
               for (let i=selIndex; i>this.selIndex; --i) {
                  this.table.querySelectorAll('tr')[i].classList.add('dv-selected');
               }
            }

            this.set.onSelected(this.getSelectedData(), row);

         }
         else {
            this.table.querySelectorAll('tr').removeClass('dv-selected');
            row.classList.add('dv-selected');
            this.set.onSelected(this.getSelectedData(), row);
         }

      }

   }

   getCount() {
      return this.data.length;
   }

   getSelectedData() {
      let data = [];
      this.table.querySelectorAll('tr.dv-selected').forEach(row => {
         data.push(row.getData('dv-item'));
      });
      return data;
   }

   setSelection(selector, selected) {
      if (typeof(selector) === 'function') {
         this.table.querySelectorAll('tr.dataview-row').forEach(function(row) {
            if (selector(row.getData('dv-item'))) {
               row.classList.add('dv-selected');
            }
         })
      }
   };

   removeSelection() {
      this.table.querySelectorAll('tr').removeClass('dv-selected');
   }

   getItemData(index) {
      return this.table.querySelectorAll('tr.dataview-row')[index].getData('dv-item');
   }


   clear() {
      this.closeExpansions();
      this.container.empty();
   }

   renderElement(element, dataItem, td) {

      let disabled = (element.disabled !== undefined && element.disabled(dataItem) === true);

      if (element.type === undefined) {

         //td.append(this.dataGetter(dataItem, dataGetter));

         td.innerHTML = this.getValue(element, 'data', dataItem);

         if (this.dataGetter(dataItem, element.editable) === true) {
            td.addEventListener('dblclick', (event) => {

               this.editedCellText = td.textContent;
               let tdWidth = td.scrollWidth;
               td.empty();

               let txt = td.createElement('input', 'editing', { type: 'text', value: this.editedCellText });
               txt.setStyles({
                  'background-color': 'white',
                  'overflow':         'hidden',
                  'border':           '2px solid red',
                  'border-radius':    '3px',
                  'width': tdWidth + 'px'
               });

               txt.addEventListener('click', (event) => { event.stopPropagation() });
               txt.addEventListener('focusout', (event) => {
                  //let item = td.getData('dv_item');
                  //let item = dataItem;
                  let newValue = event.currentTarget.value;

                  event.currentTarget.remove();
                  td.innerHTML = newValue;

                  if (this.editedCellText !== newValue) {
                     if (typeof(element.data) === 'string') {
                        dataItem[element.data] = newValue;
                        if (element.onChanged !== undefined) element.onChanged(dataItem);
                     }
                     else {
                        if (element.onChanged !== undefined) element.onChanged(dataItem, newValue);
                     }
                  }

               });
               txt.focus();
               event.preventDefault();

            });
         }

      }

      else if (element.type === 'button') {
         const label = this.getValue(element, 'label', dataItem);
         td.classList.add('dv-action');
         if (label !== false) {
            let btn = null;
            if (typeof(label) === 'object' && label instanceof HTMLElement) {
               btn = label;
               td.appendChild(label);
            }
            else if (typeof(label) === 'string') {
               btn = HTMLElement.createFromHTML(label);
               td.appendChild(btn);
            }
            else {
               throw "Falscher Variablentyp des button-labels";
            }
            btn.addEventListener('click', function(event) {
               if (!disabled) {
                  element.onClick(
                     event.currentTarget.parents('tr.dataview-row')[0].getData('dv-item'),
                     event.currentTarget.parents('tr.dataview-row')[0],
                     event
                  );
               }
               event.stopPropagation();
            });
            //const css = this.getValue(element, 'css', dataItem);
            //if (css !== false) btn.setStyles(css);
         }
      }

      else if (element.type === 'checkbox') {
         let cbx = td.createElement('input', 'dv-checkbox', { type: 'checkbox', title: element.title});
         cbx.disabled = disabled;
         cbx.addEventListener('click', function(event) {
            element.onClick(
               event.currentTarget.parents('tr.dataview-row')[0].getData('dv-item'),
               event.currentTarget.checked,
               event.currentTarget.parents('tr.dataview-row')[0]
            );
            event.stopPropagation();
         });
         cbx.checked = this.dataGetter(dataItem, element.data);
      }

      else if (element.type === 'select') {

         let sel = td.createElement('select', 'dv-select', { title: element.title });
         sel.disabled = disabled;
         sel.addEventListener('change', function(event) {
            element.onChange(
               event.currentTarget.parents('tr.dataview-row')[0].getData('dv-item'),
               event.currentTarget.value
            );
         });

         const options = this.getValue(element, 'options', dataItem);

         for (const opt of options) {
            let title = '';
            let value = '';

            if (typeof(opt) === 'string' || typeof(opt) === 'number') {
               title = value = opt;
            }
            else if (typeof(opt) === 'object') {
               title = opt.title;
               value = opt.value;
            }

            let o = sel.createElement('option', null, { value: value });
            o.innerHTML = title;
            if (String(value) == String(this.dataGetter(dataItem, element.data))) o.selected = true;

         }

      }

      const css = this.getValue(element, 'css', dataItem);
      if (css !== false) td.setStyles(css);

      const cls = this.getValue(element, 'class', dataItem);
      if (cls !== false) td.classList.add(cls);

   }

   closeExpansions() {

      if (this.set.onDestroyExpansionContent !== undefined) {
         this.container.querySelectorAll('.dataview-expanded').forEach((item) => {
            const context = item.nextSibling.getData('context');
            const content = item.nextSibling.querySelector('.dataview-expansion-content');
            this.set.onDestroyExpansionContent(context);
            item.removeClass('dataview-expanded');

            const cf = (event) => {
               event.currentTarget.removeEventListener('transitionend', cf);
               let exp = event.currentTarget.parents('.dataview-expansion')[0];
               exp.style.display = 'none';
            };

            content.addEventListener('transitionend', cf);
            content.style.maxHeight = 0;

         });
      }

   }

   toggleExpand(row) {

      let expansionRow = row.nextSibling;
      let expansionContent = expansionRow.querySelector('.dataview-expansion-content');

      // offenes Item schließen
      if (row.classList.contains('dataview-expanded')) {
         this.closeExpansions();
      }

      // alle geöffneten Items schließen, gewähltes Item öffnen
      else {
         this.closeExpansions();

         let context = {};
         expansionRow.setData('context', context);
         expansionRow.style.width = row.clientWidth + 'px';

         this.set.onCreateExpansionContent(expansionContent, context);
         this.set.onExpand(row.getData('dv-item'), context);

         row.classList.add('dataview-expanded');

         expansionRow.style.display = 'table-row';
         expansionContent.style.maxHeight = expansionContent.scrollHeight + "px";

      }

   }

   render() {

      this.clear();

      //this.table = document.createElement('table', 'dv-table', { style: 'width: 100%;' });
      this.table = document.createElement('table');
      this.table.classList.add('dv-table');

      this.numVisibleColumns = 0;

      if (this.set.multiAction !== undefined) this.numVisibleColumns++;
      if (this.set.onExpand !== false && this.onSelected === undefined) this.numVisibleColumns++;

      if (this.set.showHeader) {

         const thead = this.table.createElement('tr', "header prevent-selection");

         if (this.set.multiAction !== undefined) {
            thead.innerHTML += '<th></th>';
         }
         if (this.set.onExpand !== false && this.onSelected === undefined) {
            thead.innerHTML += '<th></th>';
         }

         for (let i=0; i<this.columns.length; ++i) {
            let col = this.columns[i];

            col.visible = col.visible === undefined ? true : col.visible;

            if (col.visible) {
               this.numVisibleColumns++;

               let th = thead.createElement('th');
               th.innerHTML = '<span style="float:left; margin-right: 5px;">' + col.title + '</span>';
               if (col.width) th.width(col.width);
               if (col.sort !== undefined) {
                  th.classList.add('sortable');
                  th.innerHTML += '<div class="sort">' +
                                     '<span class="sort-order"></span>' +
                                     '<span class="sort-dir" style="float:left;"></span>' +
                                  '</div>';

                  if (col.sort.index !== 0) {
                     th.querySelector('.sort-order').innerHTML = col.sort.index;
                     let sortDir = th.querySelector('.sort-dir');
                     sortDir.addClass(col.sort.dir === 1 ? 'ui-icon ui-icon-triangle-1-n' : 'ui-icon ui-icon-triangle-1-s');
                     sortDir.addEventListener('click', (event) => {
                        event.stopPropagation();
                        col.sort.dir *= -1;
                        this.render();
                     });
                  }

                  th.addEventListener('click', (event) => {
                     event.stopPropagation();
                     let colIndex = Number(i)
                     if (event.ctrlKey === true) {
                        this.sortSettings.push(colIndex);
                        th.querySelector('.sort-order').innerHTML = '<span style="color:red">' + this.sortSettings.length + '</span>';
                     }
                     else {
                        this.sortSettings = [colIndex];
                        this.setupSortSettings();
                        this.render();
                     }
                  });

               }
            }

         }
      }

      this.sortOrder = new Array();



      for (let column of this.columns) {
         if (column.sort !== undefined && column.sort.index > 0) {
            this.sortOrder.push({ 'column': column, 'index': column.sort.index});
         }
      }

      this.sortOrder.sort(function(a,b) { return (a.index - b.index); });

      this.data.sort(this.sortIt(this));

      let cnt = 0;

      for (let dataItem of this.data) {
         let tr = this.table.createElement('tr', 'dataview-row '+((cnt++ % 2 === 0 || this.set.oddEven === false) ? 'odd' : 'even'));
         tr.setData('dv-item', dataItem);

         if (this.set.itemCSS !== undefined) tr.setStyles(this.set.itemCSS(dataItem));

         this.table.appendChild(tr);
         let expansion = this.table.createElement('tr', 'dataview-expansion', { style: "display:none"} );
         expansion.innerHTML = '<td colspan="'+this.numVisibleColumns+'"><div class="dataview-expansion-content" style="max-height: 0; overflow: hidden; transition: max-height 0.2s ease-out 0.2s;">HAAAAAAAAAA<br/>AAAAAAAAAA<br/>AAAAAAALLLLOO<br/>OOOOOOO<br/>OOOOOOOOO!</div></td>';

         if (this.set.onSelected !== undefined) {
            tr.classList.add('dv-selectable');
            tr.addEventListener('click', (event) => {
               event.stopPropagation();
               this.select(event.currentTarget, event.shiftKey, event.ctrlKey);
            });
         }

         if (this.set.multiAction !== undefined) {
            let td = tr.createElement('td');
            td.setStyles({ width: '0px', whiteSpace: 'nowrap' });
            td.addEventListener('click', (event) => { event.stopPropagation(); });
            let input = td.createElement('input', 'dv-checkbox multiaction');
            input.setAttribute('type', 'checkbox');
         }

         if (this.set.onExpand !== false && this.onSelected === undefined) {
            let btn = tr.createElement('span', null, { style: 'float: left;'})
            btn.innerHTML = 'X';
            //let btn = $('<span class="ui-icon ui-icon-triangle-1-s" style="float: left;"></span>');
            btn.addEventListener('click', (event) => {
               event.stopPropagation();
               this.toggleExpand(event.currentTarget.parents('.dataview-row')[0]);
            });
         }

         for (let column of this.columns) {
            let td = tr.createElement('td');
            if (column.css !== undefined) td.setStyles(column.css);
            /* todo
            if (column.tooltip !== undefined) td.data('tooltip', column.tooltip(dataItem));
            */
            if (column.visible === false) continue;
            if (column.data === undefined) continue;

            if (Array.isArray(column.data)) {
               for (let element of column.data) {
                  this.renderElement(element, dataItem, td);
               }
            }

            else {
               this.renderElement(column, dataItem, td);
            }
         }

      }

      // Tooltips
      /* todo
      this.table.tooltip({
         items: "td",
         content: function() {
            return $(this).data('tooltip');
         }
      });
      */
      if (this.set.multiAction && !this.set.hideMultiActionFooter) {
         let tr = this.table.createElement('tr', 'footer');
         let td = tr.createElement('td', null, { colspan: this.numVisibleColumns });

         let btn = td.createElement('span', 'dv-action', { href: "#", style: "padding-right: .3rem" });
         btn.innerHTML = 'alle';
         btn.addEventListener('click', (event) => {
            event.stopPropagation();
            this.table.querySelectorAll('input.multiaction').forEach(item => { item.checked = true; });
         });

         btn = td.createElement('span', 'dv-action', { href: "#", style: "padding-right: .3rem" });
         btn.innerHTML = 'keine';
         btn.addEventListener('click', (event) => {
            event.stopPropagation();
            this.table.querySelectorAll('input.multiaction').forEach(item => { item.checked = false; });
         });

         btn = td.createElement('span', 'dv-action', { href: "#", style: "padding-right: .3rem" });
         btn.innerHTML = 'umkehren';
         btn.addEventListener('click', (event) => {
            event.stopPropagation();
            this.table.querySelectorAll('input.multiaction').forEach(item => { item.checked = !item.checked; });
         });

         if (this.set.multiAction.buttons) {                                                 
            for (let btn of this.set.multiAction.buttons) {
               let button = td.createElement('img', 'dv-action', { src: btn.label.icon, title: btn.label.text });
               button.addEventListener('click', () => {
                  event.stopPropagation();
                  btn.onClick(this.getMultiActionItems());
               });
            }
         }

      }

      this.container.appendChild(this.table);

   }

   load(data, settings) {

      let isIterable = (obj) => {
         if (obj == null) return false;
         return typeof obj[Symbol.iterator] === 'function';
      }

      this.data = [];
      if (Array.isArray(data)) {
         this.data = data;         
         
      }
      else if (isIterable(data)) {
         for (const i in data) this.data.push(data[i]);
      }
      else {
         console.log('DataView Fehler: die Daten müssen in einem Objekt oder einem Array übergeben werden.');
      }

      this.set = Object.extend(false, this.defaultSettings, settings);

      this.columns = settings.columns;
      this.render();

   }

};
